<div class="row">
  <mat-toolbar class="sg-nav-style">
    <div class="mr-auto">
      <a mat-button routerLinkActive="mat-primary" routerLink="/home">Home
      </a>
      <a mat-button routerLinkActive="mat-primary" routerLink="/documents"> Shared Documents
      </a>   

      <button mat-button [matMenuTriggerFor] ="metricsMenu" routerLinkActive="mat-primary" [ngClass]="{ 'mat-primary': metric.isActive }" *ngIf="displayOpenOrdersComponent">Metrics
      </button>
      <mat-menu class="sg-admin-panel sg-panel sub-menu" routerLinkActive="mat-primary" #metric="routerLinkActive" #metricsMenu="matMenu">
        <a mat-menu-item routerLinkActive="mat-primary"  routerLink="/metrics/supplierDeliveryPerformance" >Supplier Delivery Performance</a>
        <a mat-menu-item routerLinkActive="mat-primary"  *ngIf="displayOpenOrdersComponent" routerLink="/metrics/invoiceInformation" >Invoice Information</a>
        <a mat-menu-item routerLinkActive="mat-primary" *ngIf="displayOpenOrdersComponent" routerLink="/metrics/openOrders" >Open Orders</a>
        <a mat-menu-item routerLinkActive="mat-primary" *ngIf="displayOpenOrdersComponent || isSuperAdminAvailable" routerLink="/metrics/forecastReport" >Forecast Report</a>
       
        <a mat-menu-item routerLinkActive="mat-primary" *ngIf="displayOpenOrdersComponent" routerLink="/metrics/itemLeadTime" >Item Lead Time</a>
        <a mat-menu-item routerLinkActive="mat-primary" *ngIf="qrCodeScanVisible"  routerLink="/metrics/qrCodeScanMetrics" >QR Code Scan Metrics</a>
        <!-- <a mat-menu-item routerLinkActive="mat-primary"  routerLink="/metrics/historicalSupplierQuality" >Historical Supplier Quality</a> -->
        
        
      </mat-menu>
      <!-- <a mat-button routerLinkActive="mat-primary" routerLink="solarForms">Solar Forms
      </a> -->
      <button mat-button [matMenuTriggerFor]="solarFormsMenu" [ngClass]="{ 'mat-primary': solar.isActive }">Solar Forms
      </button>
      <mat-menu class="sg-admin-panel sg-panel sub-menu" routerLinkActive="mat-primary" #solar="routerLinkActive" #solarFormsMenu="matMenu">
        <a mat-menu-item mat-hover  routerLink="/solarForms/allForms" routerLinkActive="mat-primary">All Forms</a>
        <a mat-menu-item mat-hover routerLink="/solarForms/automatedForm" routerLinkActive="mat-primary">Digitized Forms</a>
      </mat-menu>


      <button mat-button [matMenuTriggerFor]="auditReportMenu"  [ngClass]="{ 'mat-primary': auditReport.isActive }" *ngIf="displayMaterialCertReportMenu"> Reports</button>
      <mat-menu class="sg-admin-panel sg-panel sub-menu" routerLinkActive="mat-primary" #auditReport="routerLinkActive" #auditReportMenu="matMenu">
        <a mat-menu-item mat-hover (click)="exportActionAuditReport()" routerLinkActive="mat-primary" *ngIf="displayAuditReportMenu" >Action Audit Report</a>
        <a mat-menu-item mat-hover (click)="exportMaterialCertData()" routerLinkActive="mat-primary" *ngIf="displayMaterialCertReportMenu" >Material Cert Report</a>
        <a mat-menu-item mat-hover (click)="exportUserReport()" routerLinkActive="mat-primary" *ngIf="displayReportMenu" >Users Report</a>
        <a mat-menu-item mat-hover (click)="exportSupplierReport()" routerLinkActive="mat-primary" *ngIf="displayReportMenu" >Suppliers Report</a>
      </mat-menu>

      <a mat-button routerLinkActive="mat-primary" routerLink="/complianceRegulations">Compliance & Regulations
      </a>

      <a mat-button routerLinkActive="mat-primary" routerLink="/branding-qr-code-generator">Branding & QR Code Generator
      </a>
     
      <button mat-button [matMenuTriggerFor]="adminMenu" [ngClass]="{ 'mat-primary': admin.isActive }" *ngIf="!userRoleType || isSuperAdminAvailable">Admin
      </button>
      <mat-menu class="sg-admin-panel sg-panel sub-menu" routerLinkActive="mat-primary" #admin="routerLinkActive"  #adminMenu="matMenu">
        <a mat-menu-item mat-hover  routerLink="/admin/userManagement" routerLinkActive="mat-primary" *ngIf="isSuperAdminAvailable || !userRoleType">User Management</a>
        <a mat-menu-item mat-hover routerLink="/admin/supplierManagement"  routerLinkActive="mat-primary" *ngIf="!isSuperAdminAvailable">Supplier Management</a>
        <a mat-menu-item mat-hover routerLink="/admin/NewsUpdatesManagement"  routerLinkActive="mat-primary" *ngIf="!isSuperAdminAvailable">News & Updates Management</a>
        <a mat-menu-item mat-hover routerLink="/admin/homeSectionsManagement"  routerLinkActive="mat-primary" *ngIf="!isSuperAdminAvailable">Home Sections Management</a>
        <a mat-menu-item mat-hover routerLink="/admin/solarFormsManagement"  routerLinkActive="mat-primary" *ngIf="!isSuperAdminAvailable">Solar Forms Management</a>
        <a mat-menu-item mat-hover routerLink="/admin/complianceRegulationsManagement"  routerLinkActive="mat-primary" *ngIf="!isSuperAdminAvailable">Compliance & Regulations</a>
        <a mat-menu-item mat-hover  (click)="onMassCommunicationClick()" routerLinkActive="mat-primary" *ngIf="!isSuperAdminAvailable">Mass Communication</a>
        <a mat-menu-item mat-hover routerLink="/admin/downtimeManagement" routerLinkActive="mat-primary" *ngIf="!isSuperAdminAvailable">Downtime Management</a>
        <a mat-menu-item mat-hover  (click)="appSettingsShow()" routerLinkActive="mat-primary" *ngIf="!isSuperAdminAvailable">Application Settings</a>
      </mat-menu>

      
    </div>
  </mat-toolbar>
</div>

<div>
  <mat-drawer-container class="application-settings sg-drawer-container" *ngIf="appSettingsTag">
    <mat-drawer class="appSettingsTag sg-drawer" mode="side" opened="true">
      <div class="row mx-0 w-100">
        <app-application-settings class="w-100" (appSettingsClose)='appSettingsClose($event)'
        (drawerClose)="drawerOpenClose($event)"></app-application-settings>
      </div>
    </mat-drawer>
  </mat-drawer-container>
</div>  
<div class="sg-spinner" style="z-index: 99999;" *ngIf="isShowLoader">
  <mat-spinner></mat-spinner>
</div>